// extracted by mini-css-extract-plugin
export var defaultWrapper = "_mp-3";
export var downloadButton = "_mp-4";
export var fileContainer = "_mp-9 _mp-7";
export var fileContainerBase = "_mp-7";
export var fileContainerFixedHeight = "_mp-8 _mp-7";
export var fileInfo = "_mp-5";
export var fileInfoWidthRestricted = "_mp-6";
export var fileType = "_mp-1";
export var fileTypeName = "_mp-2";
export var image = "_mp-0";
export var link = "_mp-b";
export var overflowEllipsis = "_mp-a";